/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { MultiContract11 } from '../models/multi-contract-11';
import { racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet } from '../fn/cache/races-race-guid-cache-datatype-datatype-fromversion-from-version-get';
import { RacesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet$Params } from '../fn/cache/races-race-guid-cache-datatype-datatype-fromversion-from-version-get';

@Injectable({ providedIn: 'root' })
export class CacheService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet()` */
  static readonly RacesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGetPath = '/races/{raceGuid}/cache/datatype/{datatype}/fromversion/{fromVersion}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet$Response(params: RacesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MultiContract11>>> {
    const obs = racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet(params: RacesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet$Params, context?: HttpContext): Observable<Array<MultiContract11>> {
    const resp = this.racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<MultiContract11>>): Array<MultiContract11> => r.body)
    );
  }

}
